module.exports = __webpack_public_path__ + "img/icdeposit.b26a60d5.png";